import { useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { useAuth, homeFor } from "@/context/AuthContext";

export default function PaymentResult() {
  const { result } = useParams();
  const [params] = useSearchParams();
  const { user } = useAuth();
  const sessionId = params.get("session_id");
  const [state, setState] = useState(result === "sucesso" && sessionId ? "checking" : "canceled");

  useEffect(() => {
    if (state !== "checking") return;
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") return setState("paid");
        if (["expired", "failed"].includes(data.status)) return setState("failed");
      } catch {
        /* keep polling */
      }
      if (++tries < 15) timer = setTimeout(poll, 2000);
      else setState("timeout");
    };
    poll();
    return () => clearTimeout(timer);
  }, [state, sessionId]);

  const map = {
    checking: [Loader2, "Confirmando pagamento com o Stripe…", "Aguarde alguns segundos.", "text-slate-400 animate-spin"],
    paid: [CheckCircle2, "Pagamento confirmado", "O Stripe confirmou o pagamento e sua situação financeira foi atualizada.", "text-emerald-500"],
    failed: [XCircle, "Pagamento não concluído", "A sessão expirou ou o pagamento foi recusado.", "text-red-500"],
    timeout: [Loader2, "Pagamento em processamento", "Ainda não recebemos a confirmação do Stripe. Ela aparecerá automaticamente no seu financeiro.", "text-amber-500"],
    canceled: [XCircle, "Pagamento cancelado", "Nenhuma cobrança foi realizada.", "text-slate-400"],
  };
  const [Icon, title, desc, cls] = map[state];
  return (
    <div className="min-h-screen grid place-items-center mat-texture p-6">
      <div className="bg-white rounded-2xl p-8 max-w-md w-full text-center space-y-4 fade-up" data-testid="payment-result">
        <Icon className={`w-14 h-14 mx-auto ${cls}`} />
        <h1 className="text-3xl font-extrabold uppercase" data-testid="payment-result-title">{title}</h1>
        <p className="text-sm text-slate-600">{desc}</p>
        <Button asChild className="bg-red-600 hover:bg-red-700" data-testid="payment-result-back-btn">
          <Link to={user ? (user.role === "admin" ? "/admin/financeiro" : `${homeFor(user)}/financeiro`) : "/login"}>Voltar</Link>
        </Button>
      </div>
    </div>
  );
}
